import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { IOrderGroupRepository } from '@/coreInfrastructureModule/interfaces/IOrderGroupRepository';
import { BulkDeleteOrderToOrderGroupAdapter } from '../adapters/bulkDeleteOrderToOrderGroupAdapter';

/**
 * 複数の発注を発注グループから外すユースケース
 */
export class BulkDeleteOrderToOrderGroupUseCase {
  private repository: IOrderGroupRepository;

  /**
   * コンストラクタ
   * @param repository - リポジトリ
   */
  constructor(repository: IOrderGroupRepository) {
    this.repository = repository;
  }

  /**
   * 複数の発注を発注グループに紐づける
   * @param orderGroupId - 発注グループID
   * @param orderIds - 複数の発注ID
   */
  public execute = async (orderGroupId: string, orderIds: string[]): Promise<INetworkResult<undefined, Error>> => {
    try {
      const request = BulkDeleteOrderToOrderGroupAdapter.adapt(orderGroupId, orderIds);
      const response = await this.repository.deleteBulkOrderToOrderGroup(request);
      switch (response.status.type) {
        case 'success':
          return {
            status: {
              type: 'success',
              data: undefined,
            },
          };
        case 'error':
          throw response.status.error;
        default:
          throw new Error('unexpected Error');
      }
    } catch (e) {
      return {
        status: {
          type: 'error',
          error: Error('想定外のエラー'),
        },
      };
    }
  };
}
